
// import React, { useState } from 'react';
// import '../styles/ManagementUploader.css';

// const ManagementQuarterlyUpdate = ({ userData }) => {
//   const [activeTab, setActiveTab] = useState("ACM Presentation");
//   const [uploadForm, setUploadForm] = useState({ title: '', file: null });
//   const [isSyncing, setIsSyncing] = useState(false);

//   const handleUpload = async () => {
//     if (!uploadForm.title || !uploadForm.file) {
//       alert("Please provide a title and select a file.");
//       return;
//     }
//     setIsSyncing(true);
//     const formData = new FormData();
//     formData.append('type', activeTab);
//     formData.append('title', uploadForm.title);
//     formData.append('attachment', uploadForm.file);
//     formData.append('empId', userData?.EmpId);

//     try {
//       const res = await fetch('/gt-api/save_quarterly_media.php', {
//         method: 'POST',
//         body: formData
//       });
//       const data = await res.json();
//       if (data.success) {
//         alert(`Successfully published to ${activeTab}!`);
//         setUploadForm({ title: '', file: null });
//       } else {
//         alert("Upload failed: " + data.message);
//       }
//     } catch (err) {
//       alert("Network error.");
//     } finally {
//       setIsSyncing(false);
//     }
//   };

//   return (
//     <div className="mgmt-container">
//       <div className="mgmt-card">
//         <h2 className="mgmt-header">Management Broadcast Tool</h2>
//         <p className="mgmt-subtitle">Upload content for the global employee feed.</p>

//         <div className="mgmt-form-stack">
//           {/* Section 1: Title */}
//           <div className="mgmt-field">
//             <label className="mgmt-label">Post Title</label>
//             <input
//               className="mgmt-input"
//               placeholder="e.g. Q4 Townhall Presentation"
//               value={uploadForm.title}
//               onChange={(e) => setUploadForm({ ...uploadForm, title: e.target.value })}
//             />
//           </div>

//           {/* Section 2: Equal Height Action Row */}
//           <div className="mgmt-field">
//             <label className="mgmt-label">Select Media</label>
//             <div className="mgmt-action-grid">
//               <input
//                 type="file"
//                 id="mgmt-file-input"
//                 hidden
//                 onChange={(e) => setUploadForm({ ...uploadForm, file: e.target.files[0] })}
//               />
//               <label htmlFor="mgmt-file-input" className={`mgmt-file-btn ${uploadForm.file ? 'file-selected' : ''}`}>
//                 <span className="btn-content">
//                   {uploadForm.file ? `✅ ${uploadForm.file.name}` : "📁 CHOOSE FILE"}
//                 </span>
//               </label>

//               <button className="mgmt-submit-btn" onClick={handleUpload} disabled={isSyncing}>
//                 <span className="btn-content">
//                   {isSyncing ? "PUBLISHING..." : "SUBMIT FEED"}
//                 </span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ManagementQuarterlyUpdate;










import React, { useState } from 'react';
import '../styles/ManagementUploader.css';

const ManagementQuarterlyUpdate = ({ userData }) => {
  const [activeTab, setActiveTab] = useState("ACM Presentation");
  const [uploadForm, setUploadForm] = useState({ title: '', file: null });
  const [isSyncing, setIsSyncing] = useState(false);

  const handleUpload = async () => {
    if (!uploadForm.title || !uploadForm.file) {
      alert("Please provide a title and select a file.");
      return;
    }
    setIsSyncing(true);
    const formData = new FormData();
    formData.append('type', activeTab);
    formData.append('title', uploadForm.title);
    formData.append('attachment', uploadForm.file);
    formData.append('empId', userData?.EmpId);

    try {
      const res = await fetch('/gt-api/save_quarterly_media.php', {
        method: 'POST',
        credentials: "include",
        body: formData
      });
      const data = await res.json();
      if (data.success) {
        alert(`Successfully published to ${activeTab}!`);
        setUploadForm({ title: '', file: null });
      } else {
        alert("Upload failed: " + data.message);
      }
    } catch (err) {
      alert("Network error.");
    } finally {
      setIsSyncing(false);
    }
  };

  return (
    <div className="mgmt-container">
      <div className="mgmt-card">
        <h2 className="mgmt-header">Management Broadcast Tool</h2>
        <p className="mgmt-subtitle">Upload content for the global employee feed.</p>

        <div className="mgmt-form-stack">
          {/* Section 1: Title */}
          <div className="mgmt-field">
            <label className="mgmt-label">Post Title</label>
            <input
              className="mgmt-input"
              placeholder="e.g. Q4 Townhall Presentation"
              value={uploadForm.title}
              onChange={(e) => setUploadForm({ ...uploadForm, title: e.target.value })}
            />
          </div>

          {/* Section 2: Equal Height Action Row */}
          <div className="mgmt-field">
            <label className="mgmt-label">Select Media</label>
            <div className="mgmt-action-grid">
              <input
                type="file"
                id="mgmt-file-input"
                hidden
                onChange={(e) => setUploadForm({ ...uploadForm, file: e.target.files[0] })}
              />
              <label htmlFor="mgmt-file-input" className={`mgmt-file-btn ${uploadForm.file ? 'file-selected' : ''}`}>
                <span className="btn-content">
                  {uploadForm.file ? `✅ ${uploadForm.file.name}` : "📁 CHOOSE FILE"}
                </span>
              </label>

              <button className="mgmt-submit-btn" onClick={handleUpload} disabled={isSyncing}>
                <span className="btn-content">
                  {isSyncing ? "PUBLISHING..." : "SUBMIT FEED"}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagementQuarterlyUpdate;









